/* Run 08 VSL page: everything below the player that the reference page does with jQuery.
   - Package rows: #pkg-tpl cloned into every [data-packages] (the reference repeats one block five times).
   - FAQ: the reference's hand-rolled accordion: every header toggles its own answer; the first FAQ starts with its
     first answer open; the repeated FAQ starts with its first header styled open but its answer closed (the reference
     shows it that way because its #acc-cont2 selector matches nothing).
   - Buy buttons (Blake 2026-10-04): like the reference (VSL card → its one-page checkout with the package preselected),
     the card goes to the VSL-only reference-style order page /pages/vsl-offer?bottle=N (+ utm_* / fbclid; theme template
     page.vsl-offer.json on the VSL SKU, Main 2026-10-04). That page does the
     main-window /cart/add.js → /checkout (tracking law rule 1) with Subscribe & Save preselected. This page makes no cart
     request. Anywhere but radiancywellness.com, or with ?preview=1: the local mockup funnel/checkout.html?bottle=N.
   - Exit-intent popup (reference js/pops.js): each time the cursor leaves the page through its top edge. Touch
     devices never fire it. Not in Blake's review mode.
   - #scrollcta: the end-card auto-click target (player.js clicks it). Reference: click/4 → its discount quiz
     (funnel-notes.md §1.4, §3). Ours: the VSL-only quiz /pages/vsl-discount (page.vsl-quiz.json) on the store, the quiz
     mockup in preview.
   Store build (theme section radiancy-vsl-page): #below carries data-order-url, data-quiz-url (theme settings; DEV uses
   /pages/contact?view=vsl-offer|vsl-quiz until the page records exist) and data-img-map (pack image name → versioned
   theme asset_url, so a re-pushed image is never served from a year-long browser cache). */
(function () {
  "use strict";

  var params = new URLSearchParams(location.search);
  var below = document.getElementById("below");
  var CFG_ORDER = below.getAttribute("data-order-url");
  var CFG_QUIZ = below.getAttribute("data-quiz-url");
  var IMG_MAP = JSON.parse(below.getAttribute("data-img-map") || "{}");
  function imgSrc(name) { return IMG_MAP[name] || "img/" + name; }
  var THEME = !!(CFG_ORDER || CFG_QUIZ);
  var REVIEW = !THEME && params.get("review") === "1";
  var STORE = THEME || (/(^|\.)radiancywellness\.com$/i.test(location.hostname) && params.get("preview") !== "1");
  var CARRY = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_id", "fbclid"];
  var MOCKUP_CHECKOUT = "../../funnel/checkout.html";
  var STORE_ORDER_PAGE = CFG_ORDER || "/pages/vsl-offer";
  var MOCKUP_QUIZ = "../../funnel/quiz.html";
  var STORE_QUIZ = CFG_QUIZ || "/pages/vsl-discount";
  function track(name, arg, arg2) {
    try { if (window.VSLTrack && typeof window.VSLTrack[name] === "function") window.VSLTrack[name](arg, arg2); } catch (err) {}
  }

  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  // ---------- Package rows (from window.OFFER, offer-config.js) ----------

  var O = window.OFFER;
  var useSub = O.vslCardPrice === "subscribe";
  var roundFn = O.cardRounding === "floor" ? Math.floor : Math.round;
  function dollars(n) { return "$" + n.toFixed(2).replace(/\.00$/, ""); }
  function cardTotal(p) { return useSub ? p.subscribe : p.oneTime; }
  var visible = O.packs.filter(function (p) { return !p.hidden; });
  var best = visible.filter(function (p) { return p.best; })[0] || visible[0];
  // Desktop row (reference): smallest pack left, best value centred, the rest right.
  var rest = visible.filter(function (p) { return p !== best; }).sort(function (a, b) { return a.bottles - b.bottles; });
  var deskOrder = {};
  if (rest.length) deskOrder[rest[0].bottles] = 1;
  deskOrder[best.bottles] = 2;
  rest.slice(1).forEach(function (p, i) { deskOrder[p.bottles] = 3 + i; });

  var tpl = document.getElementById("pkg-tpl");
  function card(p) {
    var a = tpl.content.firstElementChild.cloneNode(true);
    function slot(k) { return a.querySelector('[data-slot="' + k + '"]'); }
    a.setAttribute("data-bottles", String(p.bottles));
    a.style.setProperty("--d-order", String(deskOrder[p.bottles]));
    if (p === best) a.classList.add("pkg-best");
    slot("count").textContent = p.label;
    slot("value").textContent = p.value;
    slot("img").src = imgSrc(p.image);
    slot("img").alt = p.label;
    if (!p.seal) slot("seal").remove();
    slot("price").textContent = "$" + roundFn(cardTotal(p) / p.bottles);
    if (!useSub) slot("sub-note").remove();
    slot("regular").textContent = dollars(O.anchorPerBottle * p.bottles);
    return a;
  }
  all("[data-packages]").forEach(function (row) {
    var wrap = document.createElement("div");
    wrap.className = "pkgs";
    visible.forEach(function (p) { wrap.appendChild(card(p)); });
    row.appendChild(wrap);
  });

  // Numbers inside the page copy.
  var tokens = { "best-bottles": String(best.bottles) };
  all("[data-offer]").forEach(function (el) {
    var k = el.getAttribute("data-offer");
    if (k in tokens) el.textContent = tokens[k];
  });
  all('[data-offer-img="best"]').forEach(function (img) { img.src = imgSrc(best.image); });

  // ---------- FAQ ----------

  var faq = document.querySelector("[data-faq]");
  var faqCopy = document.querySelector("[data-faq-copy]");
  if (faq && faqCopy) {
    faqCopy.innerHTML = faq.innerHTML;
    all("[id]", faqCopy).forEach(function (el) { el.removeAttribute("id"); });
    all("[data-copy]", faqCopy).forEach(function (el) { el.removeAttribute("data-copy"); });
  }
  all(".faq").forEach(function (box, n) {
    all(".faq-q", box).forEach(function (q, i) {
      var a = q.nextElementSibling;
      q.classList.toggle("is-open", i === 0);
      a.classList.toggle("is-shown", i === 0 && n === 0);
      q.setAttribute("role", "button");
      q.setAttribute("tabindex", "0");
      q.addEventListener("click", function () {
        q.classList.toggle("is-open");
        a.classList.toggle("is-shown");
      });
      q.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); q.click(); }
      });
    });
  });

  // ---------- Buy buttons ----------

  function carried() {
    var out = new URLSearchParams();
    params.forEach(function (value, key) {
      if (CARRY.indexOf(key) !== -1 || /^utm_/.test(key)) out.append(key, value);
    });
    return out;
  }

  // base may already carry a query (DEV: /pages/contact?view=vsl-offer); the carried params are merged into it.
  function withQuery(base, q) {
    var i = base.indexOf("?");
    var merged = new URLSearchParams(i === -1 ? "" : base.slice(i + 1));
    q.forEach(function (v, k) { merged.set(k, v); });
    var qs = merged.toString();
    return (i === -1 ? base : base.slice(0, i)) + (qs ? "?" + qs : "");
  }

  function orderUrl(bottles) {
    var q = carried();
    q.set("bottle", String(bottles));
    return withQuery(STORE ? STORE_ORDER_PAGE : MOCKUP_CHECKOUT, q);
  }

  // A package card only counts as a buy click when a person could have tapped it: the card is laid out (the offer is
  // revealed). Link checkers and scanners dispatch clicks on every anchor, including the display:none cards before the
  // reveal (2026-10-05: 9 sessions, one hidden click ~14 s after load, never played). Those still navigate, but they
  // record "hidden_card", not "card". A real card click with no reveal on record (the reveal beacon was lost) records
  // "reveal:click" first, so no card click is ever without a reveal; the tracker sends it once per page load.
  document.addEventListener("click", function (e) {
    var pkg = e.target.closest && e.target.closest("a.pkg");
    if (!pkg) return;
    e.preventDefault();
    var bottles = Number(pkg.getAttribute("data-bottles"));
    if (pkg.getClientRects().length) {
      track("reveal", "click");
      track("card", bottles);
    } else {
      track("event", "hidden_card", bottles);
    }
    location.href = orderUrl(bottles);
  });

  // ---------- End-card auto-click (#scrollcta) ----------

  var endCta = document.getElementById("scrollcta");
  if (endCta) {
    endCta.addEventListener("click", function (e) {
      e.preventDefault();
      track("quizRedirect");
      location.href = withQuery(STORE ? STORE_QUIZ : MOCKUP_QUIZ, carried());
    });
  }

  // ---------- "Choose your package" bar (run 16; the theme section renders it only when its setting is on) ----------
  // The packages appear below the video with no sound or scroll, and on a phone nothing of them shows (2026-10-28 walk: 14% of
  // reveal viewers tapped a pack). The bar sits inside #below, so it exists only once the offer is revealed. It slides up
  // while the first package block is still below the screen, scrolls to it when tapped, and steps away once the packages are
  // in reach (or scrolled past). It makes no cart request and never touches the player: the video keeps playing.
  var pkgBar = document.getElementById("pkgbar");
  var pkgHead = document.querySelector("#below .bighead");
  var pkgBelow = document.getElementById("below");
  if (pkgBar && pkgHead && pkgBelow) {
    var barShown = false, barFrame = 0;
    // On while less than ~110 px of the first package block's heading is on screen (so a sliver at the bottom edge of a tall
    // phone does not count as "found"). Re-checked on scroll (one frame at a time), on resize, and when #below is revealed.
    var pkgCheck = function () {
      barFrame = 0;
      var onBar = pkgBelow.classList.contains("is-revealed") && pkgHead.getBoundingClientRect().top > window.innerHeight - 110;
      pkgBar.classList.toggle("is-on", onBar);
      pkgBar.classList.toggle("is-off", !onBar);
      if (onBar && !barShown) { barShown = true; track("event", "pkgbar", "shown"); }
    };
    var pkgSoon = function () { if (!barFrame) barFrame = window.requestAnimationFrame(pkgCheck); };
    // Keep the bar on the visible screen: when the visual viewport is shorter than the layout viewport (pinch zoom, the on-screen
    // keyboard, a browser bar that overlaps the page), lift it by the difference. env(safe-area-inset-bottom) is in the CSS.
    var vv = window.visualViewport;
    var pkgLift = function () {
      if (!vv) return;
      var lift = Math.max(0, Math.round(document.documentElement.clientHeight - vv.height - vv.offsetTop));
      pkgBar.style.setProperty("--pkgbar-lift", lift + "px");
    };
    if (vv) { vv.addEventListener("resize", pkgLift); vv.addEventListener("scroll", pkgLift); pkgLift(); }
    window.addEventListener("scroll", pkgSoon, { passive: true });
    window.addEventListener("resize", pkgSoon);
    if (window.MutationObserver) new MutationObserver(pkgSoon).observe(pkgBelow, { attributes: true, attributeFilter: ["class"] });
    window.addEventListener("load", pkgSoon);
    pkgSoon(); // a returning visitor's page is already revealed when this runs
    pkgBar.addEventListener("click", function () {
      track("event", "pkgbar", "tap");
      var calm = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var top = pkgHead.getBoundingClientRect().top + window.pageYOffset - 12;
      try { window.scrollTo({ top: top, behavior: calm ? "auto" : "smooth" }); } catch (err) { window.scrollTo(0, top); }
    });
  }

  // ---------- Exit-intent popup ----------

  var popup = document.getElementById("popup-section");
  if (popup && !REVIEW) {
    var hide = function (e) { if (e) e.preventDefault(); popup.hidden = true; };
    document.getElementById("cross").addEventListener("click", hide);
    document.getElementById("closebtn").addEventListener("click", function (e) { track("exitPopup", "clicked"); hide(e); });
    popup.querySelector(".popup-layer").addEventListener("click", hide);
    // jQuery's $(document).mouseleave = a mouseout whose relatedTarget is outside the document.
    document.addEventListener("mouseout", function (e) {
      if (e.relatedTarget) return;
      if (e.clientY <= 1) { popup.hidden = false; track("exitPopup", "shown"); }
    });
  }

  // ---------- Footer sources: closed by default; "Show sources (N)" / "Hide sources" ----------
  var refsBtn = document.getElementById("refs-toggle");
  var refsList = document.getElementById("refs-list");
  if (refsBtn && refsList) {
    var refsN = refsList.children.length;
    var setRefs = function (open) {
      refsList.hidden = !open;
      refsBtn.setAttribute("aria-expanded", String(open));
      refsBtn.textContent = open ? "Hide sources" : "Show sources (" + refsN + ")";
    };
    setRefs(false);
    refsBtn.addEventListener("click", function () { setRefs(refsList.hidden); });
    // The footer's "Scientific References" link (#sources) opens the list before jumping to it.
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest('a[href="#sources"]')) setRefs(true);
    });
  }
})();
